export const getTokensFromPattern = (pattern: string) => {
  const tokenArray = pattern.match(/[:*]([a-zA-Z]+)/g);
  return tokenArray ? tokenArray.map((token) => token.replace(/[:*]/, '')) : [];
};
